import _ from "lodash";
import { NotificationManager } from 'react-notifications';
import { Types } from "../actions/timesheetImportActions";



const defaultState = {
  timesheets: {}
};

const timesheetImportReducers = (state = defaultState, action) => {
  switch (action.type) {
    case Types.TIMESHEETIMPORT_GET_MAPPING: {

      console.log('TIMESHEETIMPORT_GET_MAPPING',action.payload)

      let newState = _.cloneDeep(state);

      newState.timesheetImport.fieldMapping = action.payload.fieldMapping;

      if (action.payload.fields){
        newState.timesheetImport.fields = action.payload.fields;
      }

      if (action.payload.ignore){
          const ignoreData = {}
          action.payload.ignore.map(value => {ignoreData[value] = true})
          newState.timesheetImport.ignore = ignoreData
      }

      return newState;
    }
    case Types.TIMESHEETIMPORT_IMPORTING_STATUS: {

      let newState = _.cloneDeep(state);

      newState.timesheetImport.importStatus = action.status;
      
      return newState;
    }
    case Types.TIMESHEETIMPORT_SHOW_MAPPING: {

      let newState = _.cloneDeep(state);

      newState.timesheetImport.showMappingSettings = action.show;
      
      return newState;
    }
    case Types.TIMESHEETIMPORT_SAVING_MAPPING: {

      let newState = _.cloneDeep(state);

      newState.timesheetImport.savingMappingStatus = action.status;

      if (!action.status){
        // finished saving mapping
        newState.timesheetImport.showMappingSettings = false;
      }
      
      return newState;
    }
    case Types.TIMESHEETIMPORT_COMPLETE: {

      let newState = _.cloneDeep(state);

      // import complete clear all pre-filled import data
      newState.timesheetImport.data = false
      newState.timesheetImport.dataToSend = false
      newState.timesheetImport.warnings = false
      newState.timesheetImport.showMappingSettings = false
      newState.timesheetImport.importStatus = false
      newState.timesheetImport.filteredTimesheets = false
      newState.timesheetImport.timesheetsOutsideOfRange = false
      newState.timesheetImport.warningsByReference = false
      
      return newState;
    }
    case Types.TIMESHEETIMPORT_FILENAME: {

      let newState = _.cloneDeep(state);

      // import complete clear all pre-filled import data
      newState.timesheetImport.filename = action.filename
      newState.timesheetImport.processingFile = true
      
      return newState;
    }
    case Types.TIMESHEETIMPORT_IMPORT_DATES: {

      let newState = _.cloneDeep(state);

      const {from,to} = action

      if (from){
        newState.timesheetImport.importFrom = from
      }
      if (to){
        newState.timesheetImport.importTo = to
      }
      
      return newState;
    }
    case Types.TIMESHEETIMPORT_DATA_LOADED: {

      let newState = _.cloneDeep(state);

      // import complete clear all pre-filled import data
      newState.timesheetImport.processingFile = false
      newState.timesheetImport.fields = action.fields
      newState.timesheetImport.data = action.data
      newState.timesheetImport.dataToSend = false

      // reset all warning data
      newState.timesheetImport.warnings = false
      newState.timesheetImport.showMappingSettings = false
      newState.timesheetImport.filteredTimesheets = false
      newState.timesheetImport.timesheetsOutsideOfRange = false
      newState.timesheetImport.warningsByReference = false
      
      return newState;
    }
    case Types.TIMESHEETIMPORT_PREPARE_FOR_PROCESSING: {

      let newState = _.cloneDeep(state);

      // import complete clear all pre-filled import data
      newState.timesheetImport.preparingForProcessing = true
      
      return newState;
    }
    case Types.TIMESHEETIMPORT_PREPARED_FOR_PROCESSING: {

      let newState = _.cloneDeep(state);

      // import complete clear all pre-filled import data
      newState.timesheetImport.preparingForProcessing = false
      newState.timesheetImport.dataToSend = action.filteredTimesheets
      
      return newState;
    }

    case Types.TIMESHEETIMPORT_PROCESSING_WARNINGS: {

      let newState = _.cloneDeep(state);

      // import complete clear all pre-filled import data
      newState.timesheetImport.processingWarnings = true
      
      return newState;
    }
    case Types.TIMESHEETIMPORT_WARNINGS: {

      let newState = _.cloneDeep(state);

      const {
        warnings,
        notFoundWarnings,
        employeesNotFound,
        ignore,
        timesheetsOutsideOfRange,
        warningsByReference
      } = action

      // import complete clear all pre-filled import data
      if (warnings) {
        newState.timesheetImport.warnings = warnings
      }
      if (notFoundWarnings){
        newState.timesheetImport.notFoundWarnings = notFoundWarnings
      }
      if (warningsByReference){
        newState.timesheetImport.warningsByReference = warningsByReference
      }
      if (timesheetsOutsideOfRange){
        newState.timesheetImport.timesheetsOutsideOfRange = timesheetsOutsideOfRange
      }

      if (employeesNotFound){
        newState.timesheetImport.employeesNotFound = employeesNotFound
      }

      if (ignore){
        newState.timesheetImport.ignore = ignore
      }

      newState.timesheetImport.processingWarnings = false
      
      return newState;
    }
    case Types.TIMESHEETIMPORT_FILE_UPLOADING: {
      let newState = _.cloneDeep(state);

      newState.timesheetImport.filesUploading = newState.timesheetImport.filesUploading
        ? [...newState.timesheetImport.filesUploading, action.file]
        : [action.file];

      return newState;
    }
    case Types.TIMESHEETIMPORT_FILE_UPLOADED: {
      let newState = _.cloneDeep(state);

      newState.timesheetImport.filesUploading = newState.timesheetImport.filesUploading.filter(
        (name) => name != action.file
      );

      const fileDetails = { name: action.file, key: action.key };
      newState.timesheetImport.filesUploaded = newState.timesheetImport.filesUploaded
        ? [...newState.timesheetImport.filesUploaded, fileDetails]
        : [fileDetails];

      NotificationManager.success(
        `You will be notified via e-mail when we process the file.`,
        `${action.file} has been uploaded.`
      );

      return newState;
    }
    case Types.TIMESHEETIMPORT_MODAL_OPEN: {
      let newState = _.cloneDeep(state);
      newState.timesheetImport.isModalOpen = action.isModalOpen;
      return newState;
    }
    case Types.TIMESHEETIMPORT_SELECT_EMPLOYEE: {
      let newState = _.cloneDeep(state);

      newState.timesheetImport.employees[action.employee] = action.selected; 

      return newState;
    }
    case Types.TIMESHEETIMPORT_DOWNLOADED_TIMESHEET_TEMPLATE: {
      let newState = _.cloneDeep(state);
      newState.timesheetImport.downloadingPdf = action.downloading;
      return newState;
    }
    case Types.TIMESHEETIMPORT_DOWNLOADING_TIMESHEET_TEMPLATE: {
      let newState = _.cloneDeep(state);
      newState.timesheetImport.downloadingPdf = action.downloading;
      return newState;
    }
    case Types.TIMESHEETIMPORT_INVALID_DATE: {
      let newState = _.cloneDeep(state);
      newState.timesheetImport.invalidDate = action.invalidDate;
      return newState;
    }
    case Types.TIMESHEETIMPORT_DATA_CLEARED: {
      let newState = _.cloneDeep(state);
      newState.timesheetImport.data = null;
      newState.timesheetImport.dataToSend = null;
      newState.timesheetImport.warnings = null;
      newState.timesheetImport.showMappingSettings = false;
      newState.timesheetImport.filteredTimesheets = null;
      newState.timesheetImport.timesheetsOutsideOfRange = null;
      newState.timesheetImport.warningsByReference = null;
      return newState;
    }

    default:
      return state;
  }
};

export default timesheetImportReducers;